import React from 'react';

import styled from 'styled-components';

import Button from 'components/lib/Button';

import { SHOP_REQUEST_PROPAGATION_MODAL_MODE } from '../constants';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid var(--line-gray);
  padding: 20px 30px 24px 30px;
`;

type Props = {
  mode: number;
  onConfirm?: () => void;
  onCancel: () => void;
};

const ShopRequestPropagateModalActions = ({ mode, onConfirm, onCancel }: Props) => {
  const hasConfirmActions = typeof onConfirm === 'function';
  return (
    <Container>
      {hasConfirmActions && mode == SHOP_REQUEST_PROPAGATION_MODAL_MODE.APPROVE && (
        <Button type={'primary'} onClick={onConfirm}>
          Approve
        </Button>
      )}
      <Button onClick={onCancel}>{mode === SHOP_REQUEST_PROPAGATION_MODAL_MODE.APPROVE ? 'Cancel' : 'Close'}</Button>
    </Container>
  );
};

export default ShopRequestPropagateModalActions;
